import { StoredCardPaymentMethod } from '@/account/types/payment-method-configuration';
import { PaymentMethod } from '../types';
import { isEmpty } from 'lodash-es';

interface PaymentHiddenInputsProps {
  paymentMethod?: PaymentMethod;
  storedPaymentMethods?: StoredCardPaymentMethod[];
  /** Should stored payment method be injected into form to send to adyen? */
  shouldAllowStoredPaymentMethods: boolean;
}

export default function PaymentHiddenInputs({
  paymentMethod,
  storedPaymentMethods,
  shouldAllowStoredPaymentMethods,
}: PaymentHiddenInputsProps) {
  const storedPayment =
    shouldAllowStoredPaymentMethods && // If we should consider using stored payment methods
    isEmpty(paymentMethod?.encryptedCardNumber) &&
    isEmpty(paymentMethod?.encryptedExpiryMonth) &&
    isEmpty(paymentMethod?.encryptedExpiryYear) &&
    storedPaymentMethods &&
    storedPaymentMethods?.length > 0
      ? storedPaymentMethods[0]
      : null;

  return (
    <>
      <input type="hidden" name="payment_method_type" value={paymentMethod?.type} />
      <input
        type="hidden"
        name="payment_method_holderName"
        value={paymentMethod?.holderName}
      />
      <input
        type="hidden"
        name="payment_method_encryptedCardNumber"
        value={paymentMethod?.encryptedCardNumber}
      />
      <input
        type="hidden"
        name="payment_method_encryptedExpiryMonth"
        value={paymentMethod?.encryptedExpiryMonth}
      />
      <input
        type="hidden"
        name="payment_method_encryptedExpiryYear"
        value={paymentMethod?.encryptedExpiryYear}
      />
      <input
        type="hidden"
        name="payment_method_encryptedSecurityCode"
        value={paymentMethod?.encryptedSecurityCode}
      />
      <input
        type="hidden"
        name="payment_method_encryptedBankAccountNumber"
        value={paymentMethod?.encryptedBankAccountNumber}
      />
      <input
        type="hidden"
        name="payment_method_encryptedBankLocationId"
        value={paymentMethod?.encryptedBankLocationId}
      />
      <input
        type="hidden"
        name="payment_method_ownerName"
        value={paymentMethod?.ownerName}
      />
      {storedPayment ? (
        <input type="hidden" name="stored_payment_method_id" value={storedPayment.id} />
      ) : null}
    </>
  );
}
